// CookieConsentContext.tsx
import { createContext, PropsWithChildren, useContext } from 'react'
import * as CookieConsent from 'vanilla-cookieconsent'
import { useCookieConsent } from './CookieConsent'

const CookieConsentContext = createContext<{ showPreferences: () => void }>({
  showPreferences: () => {}
})

export const CookieConsentProvider = ({ children }: PropsWithChildren) => {
  useCookieConsent()
  const showPreferences = () => {
    if (typeof CookieConsent.showPreferences === 'function') {
      CookieConsent.showPreferences()
    }
  }
  return (
    <CookieConsentContext.Provider value={{ showPreferences }}>
      {children}
    </CookieConsentContext.Provider>
  )
}

export const useCookieConsentApi = () => useContext(CookieConsentContext)
